/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Notes_DescInputs */

const en_fc_dl_notes_desc = /** @type {(inputs: Fc_Dl_Notes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See what changed in this version, or browse every previous release on GitHub.`)
};

/**
* | output |
* | --- |
* | "See what changed in this version, or browse every previous release on GitHub." |
*
* @param {Fc_Dl_Notes_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_notes_desc = /** @type {((inputs?: Fc_Dl_Notes_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Notes_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_notes_desc(inputs)
});
export { fc_dl_notes_desc as "fc.dl.notes.desc" }